import { render, staticRenderFns } from "./GSquareWhiteButtonWithBorder.vue?vue&type=template&id=3ca2bafe&scoped=true&"
import script from "./GSquareWhiteButtonWithBorder.vue?vue&type=script&lang=ts&"
export * from "./GSquareWhiteButtonWithBorder.vue?vue&type=script&lang=ts&"
import style0 from "./GSquareWhiteButtonWithBorder.vue?vue&type=style&index=0&id=3ca2bafe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca2bafe",
  null
  
)

export default component.exports